export default __webpack_public_path__ + "static/media/kasino.abe3ef40.jpg";